import { filter } from '../../../services/arrays';
import { strEndsWith, strStartsWith } from '../../../services/strings';
import { isTest } from './app-storage';
import { addEvent } from './dom';

let listening = false;

function isWhitelisted(origin: string): boolean {
    return strEndsWith(origin, 'get-e.com')
        || strEndsWith(origin, 'geteasytransfers.com');
}

type MsgHandler = (msg: string) => void;
type MsgFilter = (msg: string) => boolean;

const subscribers: Array<[MsgFilter, MsgHandler]> = [];

function listen(): void {
    if (listening) return;
    listening = true;

    addEvent('message', window, (event: any) => {
        const msg: string = typeof event.data === 'string'
            ? event.data
            : '';

        if (!msg || strStartsWith(msg, 'setImmediate')) return;

        // Authenticate origin
        const origin = event.origin || event.originalEvent.origin;
        let logged = false;
        if (!isTest && !isWhitelisted(origin)) {
            console.warn(`Message recieved from unknown origin ${origin}:`, msg);
            logged = true;
        }

        // Check if any subscriber wants this message
        const handlers = filter(subscribers, s => s[0](msg)).map(s => s[1]);
        if (handlers.length === 0 && !logged) {
            console.warn(`Received unknown message '${msg}' from '${origin}'`);
        }

        // Execute all handlers
        handlers.forEach(h => h(msg));
    });
}

export default function onMessage(handler: MsgHandler, msgFilter: MsgFilter | string): void {
    if (typeof msgFilter === 'string') {
        const value = msgFilter;
        msgFilter = msg => msg === value;
    }

    subscribers.push([msgFilter, handler]);
    listen();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/external-messages.ts